import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useDirectorySubItems(eventId, itemId, options = {}) {
    const { filter, sortBy: sortFunction } = options,
        subItemsSelector = useCallback((state) => state.events[eventId]?.directory.subItems[itemId], [eventId, itemId]),
        allItemsSelector = useCallback((state) => state.events[eventId]?.directory.all, [eventId]),
        subItemsIndex = useSelector(subItemsSelector) ?? [],
        allItems = useSelector(allItemsSelector),
        subItems = useMemo(() => subItemsIndex.map((id) => allItems[id]), [subItemsIndex, allItems]);

    return useMemo(() => {
        let result = subItems;

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [subItems, filter, sortBy]);
}
